import { IAccountStatus } from 'services/rtk/fbmanager/types/account';
import { IAdStatus } from 'services/rtk/fbmanager/types/ad';
import { IAdsetStatus } from 'services/rtk/fbmanager/types/adset';
import { ICabStatus } from 'services/rtk/fbmanager/types/cab';
import { ICampaignStatus } from 'services/rtk/fbmanager/types/campaign';

import { FBFiltersActionTypes, TFBFiltersActions } from './actions';

interface IFbFiltersState {
  accountsStatuses: IAccountStatus[];
  cabsStatuses: ICabStatus[];
  campaignsStatuses: ICampaignStatus[];
  adsetsStatuses: IAdsetStatus[];
  adsStatuses: IAdStatus[];
  searchProxy: string;
  proxyFilter?: number;
  search: string;
}

const initialState: IFbFiltersState = {
  accountsStatuses: [],
  cabsStatuses: [],
  campaignsStatuses: [],
  adsetsStatuses: [],
  adsStatuses: [],
  searchProxy: '',
  proxyFilter: undefined,
  search: "",
};

export const fbFiltersReducer = (state = initialState, action: TFBFiltersActions): IFbFiltersState => {
  switch (action.type) {
    case FBFiltersActionTypes.SET_ACCOUNTS_STATUSES:
      return { ...state, accountsStatuses: action.payload };
    case FBFiltersActionTypes.SET_CABS_STATUSES:
      return { ...state, cabsStatuses: action.payload };
    case FBFiltersActionTypes.SET_CAMPAIGNS_STATUSES:
      return { ...state, campaignsStatuses: action.payload };
    case FBFiltersActionTypes.SET_ADSETS_STATUSES:
      return { ...state, adsetsStatuses: action.payload };
    case FBFiltersActionTypes.SET_ADS_STATUSES:
      return { ...state, adsStatuses: action.payload };
    case FBFiltersActionTypes.SET_SEARCH_PROXY:
      return { ...state, searchProxy: action.payload };
    case FBFiltersActionTypes.SET_SEARCH:
      return { ...state, search: action.payload };
    case FBFiltersActionTypes.SET_PROXY_FILTER:
      return { ...state, proxyFilter: action.payload };
    default:
      return state;
  }
};
